import * as olProj from "ol/proj";
import Feature from "ol/Feature";
import Polygon from "ol/geom/Polygon";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Fill, Stroke, Style } from "ol/style";

import airspaceStyle from "../../../assets/js/map/airspaceStyle";
import { getPolygonCirclePoints } from "../../../assets/js/lonLatRadiusUtil.js";
import { getRequest } from '../../../axios/api'
import { wgs84ToGcj02 } from "../../../assets/js/map/ConverseLngAndLa";

var airspaceObj = {};

let featureZIndex = 0; //feature显示ZIndex
let olMap = null; //openlayer地图对象
let gVue = null; //vue对象

//显示空域
airspaceObj.showAirspace = function(ol, data, vue) {
    olMap = ol;
    gVue = vue;
    checkParam();
    const type = data.type - 1;
    const show = data.show;
    //如果是隐藏,则直接删除空域即可
    if (!show) {
        const airspaces = olMap.defaultAirspaces[type];
        if (!isEmptyArray(airspaces)) {
            olMap.defaultAirspaces[type] = []; //清空要删除的空域Feature
            reloadAirspace();
        }
    } else {
        requestAirspace(type, getAirspaceUrl(type));
    }
};

function requestAirspace(type, url) {
    getRequest(url).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
            if (!isEmptyArray(oData.data)) {
                const airspaces = oData.data;
                airspaces.forEach(airspace => {
                    drawAirspace(type, airspace);
                });
            }
        } else if (oData.code != 401) {
            gVue.$message({
                message: "获取空域失败",
                duration: 1000,
                customClass: "message-warn-s",
                iconClass: "el-icon-warn-tip",
                offset: 470,
                onClose: function() {},
            });
        }
    });
};

function getAirspaceUrl(type) {
    if (0 == type) {
        return "/basic-info-server/forbidAirspace/queryForbidAirspaceList.do";
    } else if (1 == type) {
        return "/basic-info-server/restrictAirspace/queryRestrictAirspaceList.do";
    } else if (2 == type) {
        return "/basic-info-server/erailAirspace/queryErailAirspaceList.do";
    } else if (3 == type) {
        return "/basic-info-server/cleanAirspace/queryCleanAirspaceList.do";
    } else if (4 == type) {
        return "/basic-info-server/daiwAirspace/queryDaiwAirspaceList.do";
    }
};

//显示测试空域
function drawAirspace(type, airspace) {
    const feature = getAirspaceFeature(airspace);
    const style = getAirspaceRenderStyle(type);
    feature.setStyle(style);
    let airspaces = olMap.defaultAirspaces[type];
    if (isEmptyArray(airspaces)) {
        airspaces = olMap.defaultAirspaces[type] = [];
    }
    airspaces.push(feature);
    reloadAirspace(); //重新加载空域
};

function getAirspaceFeature(data) {
    let geometery;
    if (1 === data.shapetype) {
        const points = parsePolygonPoints(data.baiduShapeDescription);
        geometery = new Polygon([points]); //绘制多边形
    } else {
        const pointss = parseCirclePoints(data.baiduShapeDescription);
        var out1 = [];
        if (0 < pointss.length) {
            for (const i in pointss) {
                var coordinate = toMercatorPoint(pointss[i][0], pointss[i][1]); //百度经纬度处理
                out1.push(coordinate);
            }
        }

        geometery = new Polygon([out1]);
    }
    const feature = new Feature({
        zIndex: featureZIndex++,
        geometry: geometery,
        data: data,
    });
    return feature;
};

function parseCirclePoints(pointStr) {
    const pointStrs = pointStr.split("-");
    //圆
    const pointss = getPolygonCirclePoints(
        parseFloat(pointStrs[0].split(",")[1]),
        parseFloat(pointStrs[0].split(",")[0]),
        parseInt(parseInt(pointStrs[1]))
    );
    return pointss;
}

function parsePolygonPoints(pointStr) {
    const points = [];
    const pointStrs = pointStr.split(";");
    pointStrs.forEach(str => {
        const pointArr = str.split(",");
        points.push(toMercatorPoint(parseFloat(pointArr[1]), parseFloat(pointArr[0])));
    });
    return points;
};

//获取空域渲染样式
function getAirspaceRenderStyle(type) {
    const airspaceStyle = getAirspaceStyle(type);
    return new Style({
        fill: new Fill({
            color: airspaceStyle.fillColorRgba,
        }),
        stroke: new Stroke({
            color: airspaceStyle.strokeColorRgba,
            width: airspaceStyle.strokeWeight,
        }),
        zIndex: ++featureZIndex,
    });
};

//获取空域的样式
function getAirspaceStyle(type) {
    if (0 == type) {
        return airspaceStyle.forbidColor;
    } else if (1 == type) {
        return airspaceStyle.restrictColor;
    } else if (2 == type) {
        return airspaceStyle.erailColor;
    } else if (3 == type) {
        return airspaceStyle.cleanColor;
    } else if (4 == type) {
        return airspaceStyle.daiwColor;
    }
};

//重新加载空域
function reloadAirspace() {
    const airspaces = olMap.defaultAirspaces;
    let showAirspaces = [];
    for (let index = 0; index < airspaces.length; index++) {
        const element = airspaces[index];
        if (!isEmptyArray(element)) {
            showAirspaces = showAirspaces.concat(element);
        }
    }
    var source = new VectorSource({
        features: showAirspaces,
        wrapX: false,
    });
    olMap.defaultAirspaceLayer.setSource(source);
};

//Google坐标转换为墨卡托坐标
function toMercatorPoint(lng, lat) {
    let coordinate = wgs84ToGcj02(lng, lat); //wgs84 经纬度处理
    return olProj.fromLonLat(coordinate); //转换后的经纬度转WEB墨卡托坐标
};

function checkParam() {
    if (isEmptyArray(olMap.defaultAirspaces)) {
        olMap.defaultAirspaces = [
            [],
            [],
            [],
            [],
            []
        ]; //初始化空域数组
    }

    if (!olMap.defaultAirspaceLayer) {
        olMap.defaultAirspaceLayer = new VectorLayer({
            zIndex: 100,
        });
        olMap.addLayer(olMap.defaultAirspaceLayer);
    }
}

function isEmptyArray(arr) {
    if (null == arr || arr.length <= 0) {
        return true;
    }
    return false;
};

export default airspaceObj;



// WEBPACK FOOTER //
// ./src/assets/js/map/airspace.js